import { render } from "./EditBudget.vue?vue&type=template&id=2d7a4316"
import script from "./EditBudget.vue?vue&type=script&lang=js"
export * from "./EditBudget.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__